export const SET_SERVICEABILITY_LOADER = "SET_SERVICEBIITY_LOADER";
export const SET_SERVICEABILITY_LIST = "SET_SERVICEBIITY_LIST";
export const GET_SERVICEABILITY_LIST = "GET_SERVICEBIITY_LIST";
export const UPLOAD_SERVICEABILITY_FILE = "UPLOAD_SERVICEABILITY_FILE"